import { TableDensity } from '@factorialco/deprecated-design-system'
import type {
  BooleanFilterCategory,
  DataTableFilter,
  DateFilterCategory,
  EntityFilterCategory,
  IdFilterCategory,
  IntegerFilterCategory,
  StringFilterCategory,
} from 'generated/resources/datatable.graphql'

export const PAGINATION_KIND = {
  OFFSET: 'offset',
  CURSOR: 'cursor',
} as const

export const DEFAULT_ITEMS_PER_PAGE = 25

export const EXPORT_FORMATS = {
  CSV: 'csv',
  EXCEL: 'xlsx',
} as const

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
} as const

export const FILTER_TYPES = {
  STRING: 'string',
  INTEGER: 'integer',
  ID: 'id',
  DATE: 'date',
  BOOLEAN: 'boolean',
  ENTITY: 'entity',
} as const

export const INTEGER_FILTER_KINDS = {
  RANGE: 'RangePicker',
  MULTIPLE_CHOICE: 'MultipleChoice',
  SINGLE_CHOICE: 'SingleChoice',
  DOCUMENTS_FOLDER_CHOICE: 'DocumentsFolderChoice',
  FREE_FIELD: 'FreeField',
} satisfies { [key: string]: IntegerFilterCategory['kind'] }

export const ID_FILTER_KINDS = {
  MULTIPLE_CHOICE: 'MultipleChoice',
  SINGLE_CHOICE: 'SingleChoice',
  DOCUMENTS_FOLDER_CHOICE: 'DocumentsFolderChoice',
  FREE_FIELD: 'FreeField',
} satisfies { [key: string]: IdFilterCategory['kind'] }

export const ENTITY_FILTER_KINDS = {
  ENTITY: 'Entity',
  EMPLOYEE: 'Employee',
} satisfies { [key: string]: EntityFilterCategory['kind'] }

export const STRING_FILTER_KINDS = {
  MULTIPLE_CHOICE: 'MultipleChoice',
  SINGLE_CHOICE: 'SingleChoice',
  SEARCH: 'SearchFilter',
  FREE_FIELD: 'FreeField',
} satisfies { [key: string]: StringFilterCategory['kind'] }

export const DATE_FILTER_KINDS = {
  DATE_PICKER: 'DatePicker',
  DATE_TIME_PICKER: 'DateTimePicker',
} satisfies { [key: string]: DateFilterCategory['kind'] }

export const BOOLEAN_FILTER_KINDS = {
  SINGLE_CHOICE: 'SingleChoice',
} satisfies { [key: string]: BooleanFilterCategory['kind'] }

export const FILTER_OPERATIONS = {
  EQUAL: 'eq',
  NOT_EQUAL: 'notEq',
  BETWEEN: 'between',
  IN: 'in',
  CONTAINS: 'contains',
} satisfies { [key: string]: DataTableFilter<unknown>['categories'][number]['operation'] }

export const selectableColumnWidth = (density: TableDensity) => (density === 'compact' ? 28 : 48)

export const EXPORT_PROJECTIONS_TYPES = {
  DATE: 'date',
  TIME: 'time',
  FLOAT: 'float',
  INTEGER: 'integer',
  RICHTEXT: 'richtext',
  STRING: 'string',
  BOOLEAN: 'boolean',
  ISO_8601: 'iso_8601',
  TEXT: 'text',
}
